import React, { useState, useEffect, useCallback, useMemo } from "react";

const Gallery = () => {
  const [selectedImg, setSelectedImg] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const galleryImages = useMemo(() => [
    { id: 1, src: "https://pixelore.s3.eu-central-003.backblazeb2.com/Gallery/image_2025-04-04_161417494.png", alt: "Phantomime10 Speck Beach Art" },
    { id: 2, src: "https://pixelore.s3.eu-central-003.backblazeb2.com/Gallery/image_2025-04-04_161432121.png", alt: "C1 Witch Speck House" },
    { id: 3, src: "https://pixelore.s3.eu-central-003.backblazeb2.com/Gallery/image_2025-04-04_161502472.png", alt: "BombaBoy Speck Art" },
    { id: 4, src: "https://pixelore.s3.eu-central-003.backblazeb2.com/Gallery/image_2025-04-04_161530403.png", alt: "Evernight Maya Art" },
    { id: 5, src: "https://pixelore.s3.eu-central-003.backblazeb2.com/Gallery/image_2025-04-04_162807040.png", alt: "Laoshi's Choose Cute Party Image" },
    { id: 6, src: "https://pixelore.s3.eu-central-003.backblazeb2.com/Gallery/image_2025-04-04_162832972.png", alt: "Choose Cute Party" },
    { id: 7, src: "https://pixelore.s3.eu-central-003.backblazeb2.com/Gallery/image_2025-04-04_162854895.png", alt: "FarmHands Birthday" },
    { id: 8, src: "https://pixelore.s3.eu-central-003.backblazeb2.com/Gallery/image_2025-04-04_162940121.png", alt: "Pixel Cats Party" },
    { id: 9, src: "https://pixelore.s3.eu-central-003.backblazeb2.com/Gallery/image_2025-04-04_162951585.png", alt: "PixelCatGuy" },
  ], []);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
    document.body.style.overflow = "auto";
  }, []);

  const navigateImages = useCallback(
    (direction) => {
      setCurrentIndex((prevIndex) => {
        const newIndex = prevIndex + direction;
        if (newIndex < 0) return galleryImages.length - 1;
        if (newIndex >= galleryImages.length) return 0;
        return newIndex;
      });
    },
    [galleryImages.length]
  );

  // Update selectedImg whenever currentIndex changes
  useEffect(() => {
    if (isModalOpen) {
      setSelectedImg(galleryImages[currentIndex]);
    }
  }, [currentIndex, isModalOpen, galleryImages]);

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        closeModal();
      } else if (isModalOpen) {
        if (e.key === "ArrowRight") {
          navigateImages(1);
        } else if (e.key === "ArrowLeft") {
          navigateImages(-1);
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isModalOpen, navigateImages, closeModal]);

  const openModal = useCallback((img, index) => {
    setSelectedImg(img);
    setCurrentIndex(index);
    setIsModalOpen(true);
    document.body.style.overflow = "hidden";
  }, []);

  return (
    <div className="gallery-container">
      <div className="mb-2">
        <h2 className="home-title">Community Gallery</h2>
        <h4 className="text-xs">If you own one of these images, and don't want it here, please dm me! Also if you want your image here!</h4>
      </div>

      <div className="gallery-grid">
        {galleryImages.map((img, index) => (
          <div
            key={img.id}
            className="gallery-item"
            onClick={() => openModal(img, index)} // Pass the index here
          >
            <img src={img.src} alt={img.alt} className="gallery-image" loading="lazy" />
          </div>
        ))}
      </div>

      {isModalOpen && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-button" onClick={closeModal}>
              ×
            </button>

            <button
              className="nav-button left-button"
              onClick={(e) => {
                e.stopPropagation();
                navigateImages(-1);
              }}
            >
              &#10094;
            </button>

            <div className="image-container">
              <img src={selectedImg.src} alt={selectedImg.alt} className="modal-image" />
              <div className="image-caption">
                {selectedImg.alt} ({currentIndex + 1}/{galleryImages.length})
              </div>
            </div>

            <button
              className="nav-button right-button"
              onClick={(e) => {
                e.stopPropagation();
                navigateImages(1);
              }}
            >
              &#10095;
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Gallery;
